import { store } from "@redux"
import createPrintRequest from "./createPrintRequest"
import getOrderPrintData from "./getOrderPrintData"

const printOrder = async (
  order,
  skipKitchenReceipt = false,
  skipOrderItems = false,
  selectedPrinters
) => {
  const printDetails =
    getOrderPrintData(order)

  const printers =
    selectedPrinters || store.getState().printers

  await Promise.all(
    printers.map(
      async (printerSettings, printerIndex) => {
        const thisPrinterOrderItems =
          printDetails.items.filter((item) =>
            item.categoryIds.some(cn =>
              printerSettings.categoryIds.includes(cn)
            )
          )

        const printPerItemEnabled =
          !skipOrderItems &&
          printerSettings.forOrderItems &&
          !printerSettings.perOrderItemQuanity

        const printPerItems =
          printPerItemEnabled ? thisPrinterOrderItems : []

        const printPerItemQuantityEnabled =
          !skipOrderItems &&
          printerSettings.forOrderItems &&
          printerSettings.perOrderItemQuanity

        const printPerItemQuantity = []

        if (printPerItemQuantityEnabled) {
          thisPrinterOrderItems.forEach(thisPrinterOrderItem => {
            for (let i = 0; i < thisPrinterOrderItem.quantity; i++) {
              printPerItemQuantity.push(thisPrinterOrderItem)
            }
          })
        }

        const noPrintPerItem =
          printPerItems.length === 0 &&
          printPerItemQuantity.length === 0

        const printKitchenReceipt =
          printerSettings.forKitchen &&
          !skipKitchenReceipt

        const printCustomerReceipt =
          printerSettings.forCustomer

        const emptyPrint =
          noPrintPerItem &&
          !printCustomerReceipt &&
          !printKitchenReceipt

        if (emptyPrint) return

        const printData = {
          ...printDetails,
          printPerItems,
          printPerItemQuantity,
          printKitchenReceipt,
          printCustomerReceipt,
          thisPrinterOrderItems
        }

        const request = {
          printType: "order",
          printData,
          printerIndex,
          printerSettings,
          saveToFailedPrints: true
        }

        try {
          await createPrintRequest(request)
        } catch (err) {
          console.log(err)
        }
      }
    )
  )
}

export default printOrder